<template>
	<div class="directive-record" v-loading="loading">
		<div class="filter">
			<gc-custom-search
				required
				class="search"
				width="500px"
				key-word="创建时间"
				type="date"
				date-picker-type="datetimerange"
				:search.sync="params['createTime']"
				:clearable="false"
			>
				<template v-slot:icon>
					<i class="iconfont icon-riqi"></i>
				</template>
			</gc-custom-search>
			<gc-custom-search
				class="search"
				key-word="指令类型"
				type="select"
				width="300px"
				:search.sync="params['cmdClass']"
				:search-option="cmdNameOptions"
				needAllForSearch
				:search-option-key="{ label: 'name', value: 'defaultValue' }"
			></gc-custom-search>
			<gc-custom-search
				class="search"
				key-word="指令状态"
				type="select"
				width="300px"
				:search.sync="params['status']"
				:search-option="cmdStatusOptions"
				:searchOptionKey="{
					label: 'name',
					value: 'defaultValue',
				}"
				needAllForSearch
			></gc-custom-search>
			<el-button v-click-blur type="primary" class="query" @click="handleQuery">查 询</el-button>
			<el-button v-click-blur @click="handleResetQuery">重 置</el-button>
			<el-button
				v-click-blur
				type="warning"
				plain
				class="query"
				v-if="tabData.deviceTypeId === 810 && tabData.subDeviceId"
				@click="securityCheckResult"
			>
				安检结果
			</el-button>
		</div>
		<div class="table">
			<gc-table
				ref="directvieTable"
				pagination-type="special"
				border
				showPage
				:columns="columns"
				:table-data="tableData"
				:page-params="pageParams"
				:current-page.sync="pageParams.currentIdOffset"
				@current-page-change="queryCommandPageList"
			></gc-table>
		</div>
		<Command-Detail :visible.sync="showDirectiveDetail" :command-detail-data="directiveDetailInfo"></Command-Detail>
	</div>
</template>

<script>
import Bus from '@/utils/eventBus'
import { apiGetCmdmodelList, apiReSend, apiCancelCommand } from '@/apis/account.api'
import CommandDetail from '@/pages/run-manage/directive-detail/CommandDetail'
import { isBlank } from '@/utils/validate'

export default {
	name: 'DirectiveRecord',
	components: { CommandDetail },
	props: {
		curTabName: String,
		tabData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			loading: false,
			params: {
				createTime: null,
				limit: 10,
				cmdClass: null,
				status: null,
			},
			tableData: [],
			pageParams: {
				hasNext: null,
				idOffset: null,
				currentIdOffset: null,
			},
			showDirectiveDetail: false,
			directiveDetailInfo: [
				{
					key: 'deviceNo',
					label: '设备通讯编号',
					value: '',
				},
				{
					key: 'detail',
					label: '指令内容',
					value: {},
				},
			],
		}
	},

	computed: {
		cmdStatusOptions() {
			return this.$store.getters.dataList.commandStatus || []
		},

		cmdNameOptions() {
			return this.$store.getters.dataList.cmdClass || []
		},

		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},

		columns() {
			return [
				{
					key: 'cmdName',
					name: '指令名称',
				},
				{
					key: 'cmdClass',
					name: '指令类型',
					tooltip: true,
				},
				{
					key: 'status',
					name: '指令状态',
					render: (h, row) => {
						const statusMap = {
							0: { class: 'dot-warning', text: '待执行' },
							1: { class: 'dot-success', text: '成功' },
							2: { class: 'dot-error', text: '失败' },
							3: { class: 'dot-error', text: '人工取消' },
						}
						const val = row.status
						return h(
							'span',
							{ class: isBlank(val) ? '' : statusMap[val]['class'] },
							isBlank(val) ? '--' : statusMap[val]['text'],
						)
					},
				},
				{
					key: 'ts',
					name: '创建时间',
					minWidth: 180,
				},
				{
					key: 'endTs',
					name: '更新时间',
					minWidth: 180,
				},
				{
					key: 'msgSource',
					name: '指令来源',
				},
				{
					key: 'cmdUserInfo',
					name: '操作员',
				},
				{
					key: 'cmdCancelUserInfo',
					name: '取消操作员',
				},
				{
					key: 'cmdErrorCodeMsg',
					name: '错误详情',
					hidden: this.tenantType === '0',
				},
				{
					key: 'operate',
					name: '操作',
					minWidth: 200,
					fixed: 'right',
					render: (h, row) => {
						const style = {
							fontSize: '14px',
							color: '#4A69FF',
							marginRight: '12px',
							cursor: 'pointer',
						}
						const ops = [
							h(
								'span',
								{
									on: {
										click: () => this.directiveDetail(row),
									},
									style,
								},
								'指令详情',
							),
							this.tenantType === '1' &&
							row.status === '2' &&
							row.msgSource === 'iot' &&
							this.$has('monitor:device:account:command:singleresend')
								? h(
										'span',
										{
											on: {
												click: () => this.handleCommandResend(row),
											},
											style,
										},
										'指令补发',
								  )
								: null,
							row.status === '0' &&
							row.msgSource === 'iot-web' &&
							this.$has('monitor:command:ledger:cmdmodel:cancel')
								? h(
										'span',
										{
											style: { ...style, color: '#e5662e' },
											on: {
												click: () => this.handleCancelCommand(row),
											},
										},
										'取消发送',
								  )
								: null,
						].filter(Boolean)
						return h('div', null, ops)
					},
				},
			].filter(m => !m.hidden)
		},
	},

	watch: {
		curTabName: {
			handler(val) {
				if (val === 'DirectiveRecord') {
					Bus.$on('refresh-command', () => {
						this.handleQuery()
					})
				} else {
					Bus.$off('refresh-command')
				}
			},
			immediate: true,
		},

		tabData: {
			handler(newVal) {
				if (newVal?.deviceTypeId) {
					this.handleResetQuery()
				}
			},
			deep: true,
		},
	},

	methods: {
		async queryCommandPageList(idOffset = '') {
			if (!this.params.createTime) return this.$message.warning('指令日期不可为空')
			this.loading = true
			const params = { idOffset, iotDeviceId: this.tabData.iotDeviceId }
			for (var key in this.params) {
				const value = this.params[key]
				if (value) {
					if (key === 'createTime') {
						params['startTime'] = value[0].getTime()
						params['endTime'] = value[1].getTime()
					} else {
						params[key] = value
					}
				}
			}
			try {
				const data = await apiGetCmdmodelList(params)
				this.tableData = data.records || []
				this.pageParams.hasNext = data.hasNext
				this.pageParams.idOffset = data.idOffset
				this.pageParams.currentIdOffset = idOffset
			} finally {
				this.loading = false
			}
		},

		handleQuery() {
			this.queryCommandPageList()
		},

		handleResetQuery() {
			this.params = this.$options.data().params
			const startTime = new Date(new Date(new Date().toLocaleDateString()).getTime())
			const endTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
			const ago = new Date(startTime - 86400000 * 7)
			const now = endTime
			this.params.createTime = [ago, now]
			this.handleQuery()
		},

		securityCheckResult() {
			const { subDeviceId, subDeviceTypeId } = this.tabData
			this.$router.push({
				name: 'deviceDetail',
				query: {
					deviceId: subDeviceId,
					deviceType: subDeviceTypeId,
				},
				params: {
					name: 'RemoteSecurityCheck',
				},
			})
		},

		directiveDetail(row) {
			this.directiveDetailInfo.map(item => {
				item.value = row[item.key]
			})
			this.showDirectiveDetail = true
		},

		async handleCancelCommand(row) {
			await this.$confirm('一旦取消不可撤回操作，请确认是否取消该指令？')
			this.loading = true
			try {
				await apiCancelCommand({ cmdId: row.cmdId, deviceNo: row.deviceNo, iotDeviceId: row.deviceId })
				this.$message.success('指令取消成功')
				this.handleQuery()
			} finally {
				this.loading = false
			}
		},

		async handleCommandResend(row) {
			await this.$confirm('你确定要补发指令吗？')
			this.loading = true
			try {
				await apiReSend({ cmdId: row.cmdId })
				this.$message.success('指令补发成功')
				this.handleQuery()
			} finally {
				this.loading = false
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.directive-record {
	@include base-button(80px);
	padding: 0 24px;
	height: 100%;
	display: flex;
	flex-direction: column;
	.filter {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin: 20px 0 24px;
		.query {
			margin-left: 20px;
		}
		.search {
			margin-right: 20px;
		}
	}
	.table {
		flex: 1;
		height: 0;
	}
}
.dialog-content {
	@include base-button(80px, 32px, 16px);
	.title {
		font-size: 14px;
		font-family: SourceHanSansCN-Medium, SourceHanSansCN;
		font-weight: 600;
		color: #222222;
		margin: 20px 0 10px;
	}
}
</style>
